import { render } from "./profileBuilder.vue?vue&type=template&id=735a1898&scoped=true"
import script from "./profileBuilder.vue?vue&type=script&lang=js"
export * from "./profileBuilder.vue?vue&type=script&lang=js"

import "./profileBuilder.vue?vue&type=style&index=0&id=735a1898&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735a1898"]])

export default __exports__